import React, { useState } from "react";

const OfficialForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_num: "",
    password: "",
    city: "",
    court: "",
    years_experience: "",
    plot_no: "",
    colony: "",
    town_village: "",
    district: "",
    group: "",
    pincode: "",
    state: "",
    internships: false,
    terms_cond: false,
    account_number: "",
    ifsc_code: "",
    bank_name: "",
    branch_name: "",
    about: "",
    profile_image: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === "file") {
      setFormData({ ...formData, profile_image: files[0] });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const payload = new FormData();
    
    // Append all form fields to the payload
    Object.keys(formData).forEach(key => {
      if (key === "profile_image" && formData[key]) {
        payload.append(key, formData[key]);
      } else if (key !== "profile_image") {
        payload.append(key, formData[key]);
      }
    });

    try {
      const response = await fetch("https://admindashboard.clns.in/api/off_client/register/", {
        method: "POST",
        body: payload,
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Success:", data);
        alert("Registration successful!");
      } else {
        console.error("Error:", response.statusText);
        alert("Registration failed. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please check your connection.");
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.formBox}>
        <h2 style={styles.heading}>Create login and password for Official</h2>
        
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Personal Information</h3>
          <input
            type="text"
            name="name"
            placeholder="Enter Official Name"
            value={formData.name}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="mobile_num"
            placeholder="Phone Number"
            value={formData.mobile_num}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="password"
            name="password"
            placeholder="Create Password"
            value={formData.password}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Professional Details</h3>
          <input
            type="text"
            name="court"
            placeholder="Court"
            value={formData.court}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="number"
            name="years_experience"
            placeholder="Years of Experience"
            value={formData.years_experience}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="group"
            placeholder="Law Group"
            value={formData.group}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <textarea
            name="about"
            placeholder="About yourself"
            value={formData.about}
            onChange={handleChange}
            style={styles.textarea}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Address Information</h3>
          <input
            type="text"
            name="plot_no"
            placeholder="Plot No."
            value={formData.plot_no}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="colony"
            placeholder="Colony"
            value={formData.colony}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="town_village"
            placeholder="Town/Village"
            value={formData.town_village}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="district"
            placeholder="District"
            value={formData.district}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="pincode"
            placeholder="PIN Code"
            value={formData.pincode}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Bank Details</h3>
          <input
            type="text"
            name="account_number"
            placeholder="Account Number"
            value={formData.account_number}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="ifsc_code"
            placeholder="IFSC Code"
            value={formData.ifsc_code}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="bank_name"
            placeholder="Bank Name"
            value={formData.bank_name}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="branch_name"
            placeholder="Branch Name"
            value={formData.branch_name}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Additional Information</h3>
          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              name="internships"
              checked={formData.internships}
              onChange={handleChange}
              id="internships"
              style={styles.checkbox}
            />
            <label htmlFor="internships" style={styles.checkboxLabel}>Available for Internships</label>
          </div>

          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              name="terms_cond"
              checked={formData.terms_cond}
              onChange={handleChange}
              required
              id="terms"
              style={styles.checkbox}
            />
            <label htmlFor="terms" style={styles.checkboxLabel}>I agree to the Terms and Conditions</label>
          </div>

          <div style={styles.fileInputContainer}>
            <label htmlFor="profile_image" style={styles.fileInputLabel}>
              Profile Image
            </label>
            <input
              type="file"
              name="profile_image"
              id="profile_image"
              onChange={handleChange}
              style={styles.fileInput}
            />
          </div>
        </div>

        <button type="submit" style={styles.button}>Add Official</button>
      </form>
    </div>
  );
};

// Enhanced Styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f4f4f4",
    padding: "20px 0",
  },
  formBox: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
    width: "600px",
    maxWidth: "90%",
  },
  heading: {
    marginBottom: "25px",
    fontSize: "24px",
    color: "#333",
    textAlign: "center",
  },
  section: {
    marginBottom: "20px",
    padding: "15px",
    backgroundColor: "#f9f9f9",
    borderRadius: "5px",
  },
  sectionTitle: {
    fontSize: "18px",
    color: "#007bff",
    marginBottom: "15px",
    borderBottom: "1px solid #eee",
    paddingBottom: "8px",
  },
  input: {
    width: "100%",
    padding: "12px",
    margin: "8px 0",
    border: "1px solid #ddd",
    borderRadius: "5px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    padding: "12px",
    margin: "8px 0",
    border: "1px solid #ddd",
    borderRadius: "5px",
    fontSize: "14px",
    minHeight: "100px",
    resize: "vertical",
    boxSizing: "border-box",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    margin: "10px 0",
  },
  checkbox: {
    marginRight: "10px",
  },
  checkboxLabel: {
    fontSize: "14px",
    color: "#555",
  },
  fileInputContainer: {
    margin: "15px 0",
  },
  fileInputLabel: {
    display: "block",
    margin: "5px 0",
    fontSize: "14px",
    color: "#555",
  },
  fileInput: {
    width: "100%",
    padding: "8px",
    border: "1px solid #ddd",
    borderRadius: "5px",
  },
  button: {
    width: "100%",
    background: "#007bff",
    color: "#fff",
    border: "none",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "20px",
    transition: "background 0.3s",
  }
};

export default OfficialForm;